export default "__VITE_ASSET__02721303__"